import { GET_CREDIT_HISTORY } from "./APILinks";
import axios from "./axios";

export const getCreditHistory = async (params) =>
  axios.get(GET_CREDIT_HISTORY, {
    params: {
      filter: params,
    },
  });
